module.exports = __webpack_public_path__ + "static/media/checkmark_grey.23986dae.png";